import { render } from "./ServicesPoste.vue?vue&type=template&id=1b3b5527&scoped=true&ts=true"
import script from "./ServicesPoste.vue?vue&type=script&lang=ts"
export * from "./ServicesPoste.vue?vue&type=script&lang=ts"

import "./ServicesPoste.vue?vue&type=style&index=0&id=1b3b5527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3b5527"]])

export default __exports__